const driverjs = require("driver.js");
const { ray } = require('node-ray/web');
window._ = require('lodash')
window.$ = window.jQuery = require('jquery')
window.ray = ray

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  require('jquery-confirm/dist/jquery-confirm.min')
  require('bootstrap4-notify/bootstrap-notify')
  require('parsleyjs/dist/parsley')
  require('perfect-scrollbar/dist/perfect-scrollbar')
  require('flatpickr/dist/flatpickr')
  require('select2/dist/js/select2.full.min')
  require('bootstrap4-duallistbox/dist/jquery.bootstrap-duallistbox')
  require('jquery-ui/dist/jquery-ui.min')
  require('dropzone/dist/dropzone')
  window.Cropper = require('cropperjs/dist/cropper.common')
  window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic')
  window.moment = require('moment/moment')

  window.markerjs2 = require('markerjs2/markerjs2')

  window.qq = require('fine-uploader/jquery.fine-uploader/jquery.fine-uploader')
  require('fine-uploader/lib/core/traditional')
  window.AF = window.AF || {}
  require('./libs/ui')

  const driverjs = require('driver.js')
  window.driver = driverjs.driver

  // Initialize Alpine.js stores
  require('./alpine/stores/index')

} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
